import Vue from 'vue'
import Router from 'vue-router'
import Home from '@/page/home/home'
import Product from '@/page/product/main'
import AboutUs from '@/page/aboutUs/main'
Vue.use(Router)

export default new Router({
  routes: [
    {
      path: '/',
      name: 'Home',
      component: Home
    },
    {
      path: '/product',
      name: 'Product',
      component: Product
    },
    {
      path: '/aboutUs',
      name: 'AboutUs',
      component: AboutUs
    },
    {
      path: '/404',
      name: '404',
      component: () => import('@/page/404/404.vue')
    }, 
    {
      path: '*',
      redirect: '/404',
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js